import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=4aabac34&lang=pug"
import script from "./Response.vue?vue&type=script&lang=ts"
export * from "./Response.vue?vue&type=script&lang=ts"
import style0 from "./Response.module.scss?vue&type=style&index=0&prod&module=true&lang=scss&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports